"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../lib/utils");

var _spinner = _interopRequireDefault(require("../spinner/spinner"));

require("./loader.css");

var Loader = function Loader(props) {
  /**
   * If opacity is set by user then honour it
   * Else if loader is Invert then set 0.5 otherwise set 0.8
   */
  var propOpacity = props.opacity,
      invert = props.invert,
      noOverlay = props.noOverlay,
      dataTestId = props.dataTestId,
      isLoading = props.isLoading,
      fullPage = props.fullPage,
      showIcon = props.showIcon,
      iconSize = props.iconSize,
      text = props.text,
      children = props.children;
  var opacity = propOpacity || (invert ? 0.5 : 0.8);
  opacity = noOverlay ? 0 : opacity;
  var background = invert ? "rgba(0,0,0,".concat(opacity, ")") : "rgba(255,255,255,".concat(opacity, ")");
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": dataTestId,
    className: (0, _utils.gatherClasses)(props, isLoading ? "oui-loader oui-show" : "oui-loader", invert ? "oui-loader-invert" : null, fullPage ? "oui-full-page" : null)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _utils.gatherClasses)(null, "oui-loader-content"),
    style: {
      background: background
    }
  }, showIcon ? /*#__PURE__*/_react["default"].createElement(_spinner["default"], {
    className: "loader-icon",
    size: iconSize
  }) : null, text ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-loader-text"
  }, text) : null), children);
};

Loader.propTypes = {
  isLoading: _propTypes["default"].bool,
  showIcon: _propTypes["default"].bool,
  text: _propTypes["default"].string,
  fullPage: _propTypes["default"].bool,
  invert: _propTypes["default"].bool,
  noOverlay: _propTypes["default"].bool,
  iconSize: _propTypes["default"].oneOf(["sm", "md", "lg"]),
  opacity: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  dataTestId: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
};
Loader.defaultProps = {
  isLoading: false,
  showIcon: true,
  text: null,
  fullPage: false,
  invert: false,
  noOverlay: false,
  iconSize: "md",
  dataTestId: "orion-loader"
};
Loader.displayName = "OrionLoader";
var _default = Loader;
exports["default"] = _default;